<div class="alert alert-info">
  A roster membership may only be moved to a different roster in the same rolling event type. In order to move the member to a different rolling event type, a new membership must be purchased.
</div>

<div class="form-group">

  <label>New Roster</label>

  <select class="custom-select" *ngIf="loadingRosters">
    <option disabled class="disabled">
      Loading rosters...
    </option>
  </select>
  <select class="custom-select" *ngIf="!loadingRosters" [(ngModel)]="selectedRosterId">
    <option *ngFor="let roster of rosters" [ngValue]="roster.id">
      {{ roster.name }}
    </option>
    <option disabled class="disabled" *ngIf="rosters.length === 0" [ngValue]="null">
      No alternative rosters available
    </option>
  </select>

</div>

<div class="alert alert-info mb-0">
  The member will be removed from all future events in their current roster, and will be added to the new roster's events.
</div>

<div class="alert alert-danger mt-3 mb-0" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
